<template>
	<el-select
		ref="input"
		class="input-sigarus-select"
		placeholder="Selecciona"
		no-match-text="No se han encontrado coincidencias"
		no-data-text="Sin datos"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
		@focus="onFocus"
		@blur="$emit('blur')"
		clearable
	>

		<el-option
			v-for="item in list"
			:key="item.value"
			:label="item.label"
			:value="item.value"
			:disabled="item.disabled || false"
		/>

	</el-select>
</template>

<script>
	export default {
		name: 'InputSigarusSelect',
		props: {
			value: {
				default: ''
			}
		},
		data () {
			return {
				list: []
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) {
					this.$emit('input', val)
					this.$emit('save', val)

					if (this.multiple && this.$refs.input) {
						this.$refs.input.blur()
					}
				}
			}
		},
		created () {

			this.list = this.options

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			onFocus() {
				
				this.$emit('focus')

				if (!this.remote) return
				
				this.remoteMethod()

			}
		}
	}
</script>
